var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 125,
    viewBox: "0 0 202 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 125,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04784 30.4152L61.5285 30.4152L136.951 95.275L173.154 95.2749",
    stroke: "#74797D",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.106 30.4152L134.71 30.4152L59.2874 95.2749L7.99985 95.2749",
    stroke: "#74797D",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.628 94.7265C201.116 95.1266 201.116 95.8734 200.628 96.2735L172.027 119.709C171.374 120.244 170.393 119.779 170.393 118.936V72.0645C170.393 71.2205 171.374 70.7561 172.027 71.291L200.628 94.7265Z",
    fill: "#74797D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.056 28.7265C201.544 29.1266 201.544 29.8734 201.056 30.2735L172.455 53.709C171.802 54.2439 170.821 53.7795 170.821 52.9355V6.06449C170.821 5.22052 171.802 4.75608 172.455 5.29099L201.056 28.7265Z",
    fill: "#74797D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 125,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateIcon);
export default __webpack_public_path__ + "static/media/state_icon.4a0f01c2214cf4cfe9802808974e0ed5.svg";
export { ForwardRef as ReactComponent };